module.exports = __webpack_public_path__ + "img/detail1.1cda95f1.png";